<template>
  <div>
    <h1>{{ $t("deputyAuth.form.title") }}</h1>
    <delegation-substitutes-menu />
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <deputy-auth-form @saved="load">
          <v-btn block color="accent">{{ $t("deputyAuth.newDeputyAuth") }}</v-btn>
        </deputy-auth-form>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="deputyAuthItems" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.absent_user_name }}</td>
          <td class="text-left">{{ props.item.substitute_user_name }}</td>
          <td class="text-left">
            {{ props.item.from_date == null ? $t("global.noSetTime") : props.item.from_date }}
          </td>
          <td class="text-left">
            {{ props.item.to_date == null ? $t("global.noSetTime") : props.item.to_date }}
          </td>
          <td class="text-left">
            <v-tooltip top>
              <template #activator="{on}">
                <span v-on="on">{{ props.item.item_name }}</span>
              </template>
              {{ props.item.item_description }}
            </v-tooltip>
          </td>
          <td class="text-left">{{ props.item.comment }}</td>
          <td class="text-center px-0">
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="remove(props.item)" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              {{ $t("global.delete") }}
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
//    import VehicleDialog from './VehicleDialog.vue';
import DelegationSubstitutesMenu from "../../components/DelegationSubstitutesMenu";
import DeputyAuthForm from "../../components/UserSubstitute/DeputyAuthForm"; // webpack alias

export default {
  name: "SubstitutesDeputyAuthView",
  components: { DeputyAuthForm, DelegationSubstitutesMenu },
  data: () => ({
    search: "",
    deputyAuthItems: []
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("deputyAuth.absentUser"), value: "absent_user_name" },
        {
          text: this.$t("deputyAuth.substituteUser"),
          value: "substitute_user_name"
        },
        { text: this.$t("deputyAuth.fromTime"), value: "from_date" },
        { text: this.$t("deputyAuth.toTime"), value: "to_date" },
        { text: this.$t("deputyAuth.permissionName"), value: "item_name" },
        { text: this.$t("global.comment"), value: "comment" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
    // vehicles: function () {
    //     return this.$store.getters['Vehicle/vehicleList'];
    // }
  },
  methods: {
    load() {
      this.axios.get("deputy-auth/deputy-auth-list").then(resp => {
        this.deputyAuthItems = resp.data;
      });
    },
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("userSubstitute.dialogConfirmRemove.content"),
        title: this.$t("userSubstitute.dialogConfirmRemove.title")
      });
      dialog.then(() => {
        this.axios.post("deputy-auth/remove-deputy-auth", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("userSubstitute.dialogConfirmRemove.done"),
            position: "down"
          });
        });
      });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped></style>
